import { FrameLoader } from "./FrameLoader.js";
class FrameTriggerLoader extends FrameLoader {
  /**
   * Config.
   */
  static config = {
    name: "FrameTriggerLoader"
  };
}
export {
  FrameTriggerLoader
};
//# sourceMappingURL=FrameTriggerLoader.js.map
